import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Banner from "./component";
import { useApiRequest } from "../Components/Login/Hooks/useApiRequest";
import { API_BASE_URL } from "../config";
const Banner_Container = ({ vmid }) => {
  const navigate = useNavigate();
  const { makeApiRequest } = useApiRequest();
  const [bannerData, setBannerData] = useState([]);
  const [loading, setLoading] = useState(false);
  //console.log("vmid",vmid)

  // Redirect if user is not logged in
  useEffect(() => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    if (!UserJWTAuth) navigate("/login");
  }, [navigate]);

  // Fetch banners
  const fetchBanners = () => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");

    setLoading(true);

    makeApiRequest({
      url: `${API_BASE_URL}/order/fetch/banners`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        //"x-app-platform": "web",
        //"x-app-version": "v1.0.1",
        //"x-device-id": deviceId,
      },
      data: {
        request: {
          vendingMachineId: vmid,
        },
      },
      handleSuccess: (res) => {
         //console.log("banners",res.data.response.banners)
        setBannerData(res.data.response.banners|| []);
        setLoading(false);
      },
      handleError: (err) => {
        setLoading(false);
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          navigate("/login");
        } else {
         /*  toast.error(err?.response?.data?.status?.code || "Failed to fetch banners", {
            position: "top-right",
            autoClose: 1500,
          }); */
        }
      },
    });
  };

  // Fetch banners on mount
  useEffect(() => {
    if (navigator.onLine) {
      fetchBanners();
    }
  }, [vmid]);

  // Show loading or Banner component
  return (
    <>
      {loading && <p>Loading banners...</p>}
      {!loading && bannerData.length > 0 && <Banner bannerData={bannerData} />}
      {!loading && bannerData.length === 0 && navigator.onLine && (
       /*  <p>No banners found for this vending machine.</p> */
       <>
       </>
      )}
    </>
  );
};

export default Banner_Container;
